/**
 * Fallback keyboard scopes for tables that don't pass one.
 *
 * Same values the table used before it moved out of sales-portal, so nothing
 * changes for existing tables. Prefer passing your own scope.
 */

/** Used by {@link Table}. */
export const DEFAULT_TABLE_KEYBOARD_SCOPE = 'ORDER_ENTRY_TABLE';

/** Used by {@link useTableKeyboardNavigation}. */
export const DEFAULT_TABLE_NAVIGATION_SCOPE = 'GLOBAL';
